
import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { RefreshCw, Building2 } from "lucide-react";

interface LoadingSpinnerProps {
  onRetry?: () => void;
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  onRetry, 
  message = "Laddar innehåll..." 
}) => {
  const [showRetryOption, setShowRetryOption] = useState(false);

  // Show retry option after 3 seconds (reduced for faster feedback)
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowRetryOption(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center p-12 w-full animate-fade-in">
      <div className="relative mb-6">
        <div className="p-4 bg-gradient-to-br from-primary/10 to-primary/20 rounded-full">
          <Building2 className="h-8 w-8 text-primary" />
        </div>
        <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-primary animate-spin"></div>
      </div>
      
      <h3 className="text-lg font-medium text-slate-800 mb-2">Laddar dina projekt</h3>
      <p className="text-slate-600 text-sm mb-4">{message}</p>
      
      {!showRetryOption ? (
        <p className="text-slate-400 text-xs">Detta kan ta några sekunder...</p>
      ) : (
        <div className="text-center animate-fade-in">
          <p className="text-slate-500 text-sm mb-3">Tar det längre tid än väntat?</p>
          {onRetry && (
            <Button 
              onClick={onRetry}
              variant="outline"
              size="sm"
              className="flex items-center gap-2"
            >
              <RefreshCw className="h-4 w-4" />
              Försök igen
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default LoadingSpinner;
